export default {
    'ERROR-GET-REFERRAL-CAMPAIGNS-ADMIN': {
        'GET-REFERRAL-CAMPAIGN-ADMIN-ERROR': {
            actionType: 'toast',
            message: {
                fr: "Impossible de récupérer les campagnes de parrainage.",
                en: 'Failed to retrieve the referral campaigns.',
            },
            // redirectPath: '/referral-campaigns',
        },
    },
    'ERROR-GET-AUDIENCE-ADMIN': {
        'GET-AUDIENCE-ADMIN-ERROR': {
            actionType: 'toast',
            message: {
                fr: "Impossible de récupérer l'audience.",
                en: 'Failed to retrieve the audience.',
            },
        },
    },
    'ERROR-GET-REFERRAL-CAMPAIGN-EDIT-ADMIN': {
        'GET-REFERRAL-CAMPAIGN-ADMIN-ERROR': {
            actionType: 'redirect',
            message: {
                fr: "Impossible de récupérer les informations d'édition de la campagne.",
                en: 'Failed to retrieve the referral campaign edit details.',
            },
            redirectPath: '/referral',
        },
    },
    'ERROR-GET-REFERRAL-CAMPAIGN-MANAGE-ADMIN': {
        'GET-REFERRAL-CAMPAIGN-ADMIN-ERROR': {
            actionType: 'redirect',
            message: {
                fr: "Impossible de récupérer les informations de gestion de la campagne.",
                en: 'Failed to retrieve the referral campaign management details.',
            },
            redirectPath: '/referral',
        },
    },
    'ERROR-CREATE-REFERRAL-CAMPAIGN-ADMIN': {
        'CREATE-ONE-CAMPAIGN-REFERRAL-MISSING-NAME': {
            actionType: 'toast',
            message: {
                fr: "Le nom de la campagne est requis.",
                en: 'The campaign name is required.',
            },
        },
    },
    'ERROR-UPDATE-REFERRAL-CAMPAIGN-REWARDS-ADMIN': {
        'UPDATE-ONE-REFERRAL-CAMPAIGN-NOT-FOUND': {
            actionType: 'redirect',
            message: {
                fr: "La campagne de parrainage spécifiée est introuvable.",
                en: 'The specified referral campaign was not found.',
            },
            redirectPath: '/referral',
        },
        'UPDATE-ONE-REFERRAL-CAMPAIGN-REWARDS-NOT-UPDATED': {
            actionType: 'toast',
            message: {
                fr: "La mise à jour des récompenses de la campagne a échoué.",
                en: 'Failed to update the campaign rewards.',
            },
        },
    },
    'ERROR-UPDATE-REFERRAL-CAMPAIGN-AMBASSADORS-ADMIN': {
        'UPDATE-ONE-REFERRAL-CAMPAIGN-NOT-FOUND': {
            actionType: 'redirect',
            message: {
                fr: "La campagne de parrainage spécifiée est introuvable.",
                en: 'The specified referral campaign was not found.',
            },
            redirectPath: '/referral',
        },
        'UPDATE-ONE-REFERRAL-CAMPAIGN-COMMUNICATION-NOT-UPDATED': {
            actionType: 'toast',
            message: {
                fr: "La mise à jour des ambassadeurs de la campagne a échoué.",
                en: 'Failed to update the campaign ambassadors.',
            },
        },
    },
    'ERROR-UPDATE-REFERRAL-CAMPAIGN-COMMUNICATION-ADMIN': {
        'UPDATE-ONE-REFERRAL-CAMPAIGN-NOT-FOUND': {
            actionType: 'redirect',
            message: {
                fr: "La campagne de parrainage spécifiée est introuvable.",
                en: 'The specified referral campaign was not found.',
            },
            redirectPath: '/referral',
        },
        'UPDATE-ONE-REFERRAL-CAMPAIGN-COMMUNICATION-MISSING-CHANNEL': {
            actionType: 'toast',
            message: {
                fr: "Vous devez sélectionner au moins un canal (email ou SMS).",
                en: 'You must select at least one channel (email or SMS).',
            },
        },
        'UPDATE-ONE-REFERRAL-CAMPAIGN-EMAIL-INFO-INVALID': {
            actionType: 'toast',
            message: {
                fr: "L'email est invalide : le sujet et le message sont obligatoires.",
                en: 'The email is invalid: subject and message are required.',
            },
        },
        'UPDATE-ONE-REFERRAL-CAMPAIGN-RECURRING-MISSING-RECURRENCE': {
            actionType: 'toast',
            message: {
                fr: "Une récurrence est nécessaire pour les campagnes récurrentes.",
                en: 'Recurrence is required for recurring campaigns.',
            },
        },
        'UPDATE-ONE-REFERRAL-CAMPAIGN-INVALID-DATE': {
            actionType: 'toast',
            message: {
                fr: "La date de début est invalide.",
                en: 'The start date is invalid.',
            },
        },
    },
    'ERROR-UPDATE-REFERRAL-CAMPAIGN-ADVANCED-ADMIN': {
        'UPDATE-ONE-REFERRAL-CAMPAIGN-NOT-FOUND': {
            actionType: 'redirect',
            message: {
                fr: "La campagne de parrainage spécifiée est introuvable.",
                en: 'The specified referral campaign was not found.',
            },
            redirectPath: '/referral',
        },
        'UPDATE-ONE-REFERRAL-CAMPAIGN-ADVANCED-NOT-UPDATED': {
            actionType: 'toast',
            message: {
                fr: "La mise à jour des informations avancées a échoué.",
                en: 'Failed to update advanced information.',
            },
        },
    },
    'ERROR-UPDATE-REFERRAL-CAMPAIGN-STATUS-ADMIN': {
        'CHANGE-STATUS-REFERRAL-CAMPAIGN-NOT-FOUND': {
            actionType: 'redirect',
            message: {
                fr: "La campagne de parrainage spécifiée est introuvable.",
                en: 'The specified referral campaign was not found.',
            },
            redirectPath: '/referral',
        },
        'CHANGE-STATUS-ALREADY-IN-STATUS': {
            actionType: 'toast',
            message: {
                fr: "La campagne est déjà dans cet état.",
                en: 'The campaign is already in this status.',
            },
        },
        'CHANGE-STATUS-INVALID-START-DATE': {
            actionType: 'toast',
            message: {
                fr: "La date de début est invalide pour lancer la campagne.",
                en: 'The start date is invalid to launch the campaign.',
            },
        },
    },
    'ERROR-UPDATE-REFERRAL-STATUS-ADMIN': {
        'CHANGE-STATUS-REFERRAL-NOT-FOUND': {
            actionType: 'redirect',
            message: {
                fr: "La recommandation spécifiée est introuvable.",
                en: 'The specified referral was not found.',
            },
            redirectPath: '/referral',
        },
        'CHANGE-STATUS-REFERRAL-INVALID-STATUS': {
            actionType: 'toast',
            message: {
                fr: "Le statut actuel de la recommandation ne permet pas cette action.",
                en: 'The current referral status does not allow this action.',
            },
        },
    },
};
